var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-button download-btn",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.clickDownLoad(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.$t('download'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }